import {DriverLanguageEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function driverLanguageNameFilter(language: DriverLanguageEnum): string {
  switch (language) {
    case DriverLanguageEnum.Pl: return i18n.t(LF.Polish) as string
    case DriverLanguageEnum.En: return i18n.t(LF.English) as string
    case DriverLanguageEnum.Ru: return i18n.t(LF.Ukrainian) as string
    case DriverLanguageEnum.Cz: return i18n.t(LF.Czech) as string

  }
}
